module.exports = __webpack_public_path__ + "img/imgmale.980c7737.svg";